function parseBookingDateTime(dateStr, timeStr) {
  let targetDate = dateStr;
  if (!targetDate || typeof targetDate !== 'string') {
    targetDate = new Date().toISOString().split('T')[0];
  }

  let hours = 9;
  let minutes = 0;

  if (timeStr && typeof timeStr === 'string') {
    const ampmMatch = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
    if (ampmMatch) {
      let h = parseInt(ampmMatch[1], 10);
      const m = parseInt(ampmMatch[2], 10);
      const isPm = ampmMatch[3].toUpperCase() === 'PM';

      if (isPm && h < 12) h += 12;
      if (!isPm && h === 12) h = 0;

      hours = h;
      minutes = m;
    } else {
      const match24 = timeStr.match(/(\d{1,2}):(\d{2})/);
      if (match24) {
        hours = parseInt(match24[1], 10);
        minutes = parseInt(match24[2], 10);
      }
    }
  }

  const pad = (n) => String(n).padStart(2, '0');
  const isoStr = `${targetDate}T${pad(hours)}:${pad(minutes)}:00`;
  const parsed = new Date(isoStr);

  if (isNaN(parsed.getTime())) {
    return new Date();
  }
  return parsed;
}

/**
 * Generates and triggers browser download of an .ics calendar file for the client.
 * @param {object} bookingData
 * @param {string} meetLink
 */
export function downloadClientIcsFile(bookingData, meetLink = '') {
  const durationMinutes = (bookingData.consultation_type || '').includes('60') ? 60 : 30;
  const startDate = parseBookingDateTime(bookingData.meeting_preferred_date, bookingData.preferred_time);
  const endDate = new Date(startDate.getTime() + durationMinutes * 60 * 1000);

  const formatIcsDate = (date) => {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const dtStart = formatIcsDate(startDate);
  const dtEnd = formatIcsDate(endDate);
  const dtStamp = formatIcsDate(new Date());

  const clientName = `${bookingData.firstname || ''} ${bookingData.lastname || ''}`.trim() || 'Client';
  const summary = `1-on-1 Strategy Session: ${clientName} & Grow & Stay Rich`;
  const location = meetLink || 'https://meet.google.com/piw-qsyu-fqg';
  const description = `Your 1-on-1 Financial Strategy Session with Grow & Stay Rich.\\n\\n` +
    `Client: ${clientName} (${bookingData.email})\\n` +
    `Timezone: Central Time (CT)\\n` +
    `Meeting Link: ${location}\\n` +
    `Host: Priyanka Karn (priyankakarn@growandstayrich.com)`;

  const icsLines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Grow & Stay Rich//Booking System//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:REQUEST',
    'BEGIN:VEVENT',
    `UID:booking-${Date.now()}@growandstayrich.com`,
    `DTSTAMP:${dtStamp}`,
    `DTSTART:${dtStart}`,
    `DTEND:${dtEnd}`,
    `SUMMARY:${summary}`,
    `DESCRIPTION:${description}`,
    `LOCATION:${location}`,
    `ORGANIZER;CN="Priyanka Karn":MAILTO:priyankakarn@growandstayrich.com`,
    `ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=ACCEPTED;CN=${clientName}:MAILTO:${bookingData.email}`,
    `STATUS:CONFIRMED`,
    'END:VEVENT',
    'END:VCALENDAR'
  ];

  const icsData = icsLines.join('\r\n');
  const blob = new Blob([icsData], { type: 'text/calendar;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'GrowAndStayRich_StrategySession.ics');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
